module.exports = __webpack_public_path__ + "img/2.5KG.e19adfd5.jpg";